import { ProductType } from './ProductType';

class SubMenu {
  constructor(params) {
    this.name = params.name;
    this.id = params.id;
    this.index = params.index;
    this.image = params.image;
    this.nameColor = params.nameColor;
    this.productTypes = (params.productTypes || []).map(data => new ProductType(data));
  }
}

export { SubMenu };



// WEBPACK FOOTER //
// ./src/models/SubMenu.js